import { render, staticRenderFns } from "./ProgressDots.vue?vue&type=template&id=174bb7a2&scoped=true&"
import script from "./ProgressDots.vue?vue&type=script&lang=js&"
export * from "./ProgressDots.vue?vue&type=script&lang=js&"
import style0 from "./ProgressDots.vue?vue&type=style&index=0&id=174bb7a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174bb7a2",
  null
  
)

export default component.exports